import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=d2ee1476&scoped=true&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"
import style0 from "./Post.vue?vue&type=style&index=0&id=d2ee1476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ee1476",
  null
  
)

export default component.exports